function planLimitBlockStorageKey(subscriptionId) {
  return "plan_limit_block_violation_keys_" + subscriptionId;
}

$(document).on("turbo:before-cache", function () {
  const modal = $("#plan-limit-block-modal");

  if (!modal.length) {
    return;
  }

  // Close before Turbo snapshots: a restored entry must not come back half-open
  // (turbo:load re-opens it cleanly).
  modal.removeClass("in").css("display", "none");
  $(".modal-backdrop").remove();
  $("body").removeClass("modal-open").css("padding-right", "");
});

let planLimitBlockForcingVisit = false;

// MWAI renders main content in `mwai-main-frame`; a frame render keeps only that
// subtree and drops the layout-level block modal — force a top-level visit.
$(document).on("turbo:before-frame-render", function (event) {
  if (planLimitBlockForcingVisit) {
    return;
  }

  const responseDocument = event.originalEvent && event.originalEvent.detail &&
    event.originalEvent.detail.newFrame && event.originalEvent.detail.newFrame.ownerDocument;

  if (!responseDocument || !responseDocument.querySelector("#plan-limit-block-modal")) {
    return;
  }

  if (document.querySelector("#plan-limit-block-modal")) {
    return;
  }

  planLimitBlockForcingVisit = true;
  if (window.Turbo) {
    window.Turbo.visit(window.location.href, { action: "replace" });
  }
});

$(document).on("turbo:load", function () {
  planLimitBlockForcingVisit = false;

  const clearMarker = $("#plan-limit-block-clear");

  if (clearMarker.length) {
    sessionStorage.removeItem(planLimitBlockStorageKey(clearMarker.data("subscription-id")));
    return;
  }

  const modal = $("#plan-limit-block-modal");

  if (!modal.length) {
    return;
  }

  const storageKey = planLimitBlockStorageKey(modal.data("subscription-id"));
  const currentKeys = modal.find(".plan-limit-block-items li").map(function () {
    return String($(this).data("violation-key"));
  }).get();

  let initialKeys = [];
  try {
    initialKeys = JSON.parse(sessionStorage.getItem(storageKey)) || [];
  } catch (e) {
    initialKeys = [];
  }
  currentKeys.forEach(function (key) {
    if (initialKeys.indexOf(key) === -1) { initialKeys.push(key); }
  });
  sessionStorage.setItem(storageKey, JSON.stringify(initialKeys));

  const resolvedCount = initialKeys.filter(function (key) {
    return currentKeys.indexOf(key) === -1;
  }).length;
  modal.find(".plan-limit-block-progress").text(resolvedCount + " of " + initialKeys.length + " resolved");
  modal.find(".plan-limit-block-progress-bar span").css("width", (resolvedCount / initialKeys.length) * 100 + "%");

  modal.modal({ show: true, backdrop: "static", keyboard: false });

  if (!sessionStorage.getItem("plan_limit_block_displayed")) {
    window.trackPicoUserAction("plan_limit_block_displayed", {});
    sessionStorage.setItem("plan_limit_block_displayed", "true");
  }
});

$(document).on("click", ".plan-limit-block-action", function () {
  window.trackPicoUserAction("plan_limit_block_action_clicked", {
    violation_key: $(this).closest("li").data("violation-key") || ""
  });
});
